<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="应用名称">
            <el-select v-model="searchForm.appIndex" placeholder="请选择">
              <el-option
                v-for="item in apps"
                :key="item.appIndex"
                :label="item.appName"
                :value="item.appIndex">
              </el-option>
            </el-select>
            <!--<el-input v-model="searchForm.appIndex"></el-input>-->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="getAppProducts">查询</el-button>
            <el-button type="success" @click="showDialog(false)">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table :data="appGames.rows" :stripe="true" v-loading="loading" border style="width: 100%">
          <el-table-column prop="id" width="80" label="ID" v-if="false"></el-table-column>
          <el-table-column prop="appIndex" label="应用名称">
            <template slot-scope="scope">
              {{findAppName(scope.row.appIndex)}}
            </template>
          </el-table-column>
          <el-table-column prop="appKey" label="游戏名称">
            <template slot-scope="scope">
              {{findGameName(scope.row.appKey)}}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-switch
                @change="statusChange(scope.row)"
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="正常"
                inactive-text="维护"
                :active-value="0"
                :inactive-value="2">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="160" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteAppGames(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="padding-vertical-md"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="appGames.currentPage"
          :page-sizes="pageSizes"
          :page-size="appGames.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="appGames.count">
        </el-pagination>
      </el-col>
    </el-row>
    <!--编辑面板-->
    <el-dialog el-dialog :title="title" :visible.sync="showEditorDialog" class="update"
               :before-close="handleBeforeCloseDialog">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="formRules">
        <el-form-item label="应用" prop="appIndex">
          <el-select v-model="formData.appIndex" placeholder="请选择">
            <el-option
              v-for="item in apps"
              :key="item.appIndex"
              :label="item.appName"
              :value="item.appIndex">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="游戏" prop="appKey">
          <el-select v-model="formData.appKey" placeholder="请选择">
            <el-option
              v-for="item in games"
              :key="item.appKey"
              :label="item.name"
              :value="item.appKey">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="padding-top-sm" align="center">
        <el-button type="primary" native-type="submit" @click.native.prevent="handleSubmit('formData')">保存</el-button>
        <el-button @click="closeDialog">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  import _Find_ from 'lodash/find'
  import {getApps} from '@/api/apps'
  import constant from '@/utils/constant'
  import Promise from 'bluebird'
  import {
    getGames
  } from '@/api/games';
  import {
    getGamesConfig,
    saveGameConfig,
    updateGameConfig,
    deleteGameConfig,
    updateGamesStatus
  } from '@/api/appGames';

  const STATUS = {
    ENABLE: 1, // 启用/正常
    DISABLE: 0 // 禁用/维护
  }

  function defaultForm() {
    return {
      appIndex: '',
      appKey: ''
    };
  }

  export default {
    name: 'appGames',
    data() {
      return {
        loading: true,
        apps: [],
        games: [],
        appGames: [],
        title: '',
        showEditorDialog: false,
        formData: defaultForm(),
        searchForm: {
          appIndex: null
        },
        formRules: {
          appIndex: [{required: true, trigger: 'blur', message: '应用Index只能输入数字'}],
          appKey: [{required: true, trigger: 'blur', message: '应用Index只能输入数字'}],
        },
        pageSizes: constant.PAGINATION.pageSizes
      };
    },
    /**
     * 初始化钩子
     */
    created() {
      this.loadData();
    },
    methods: {
      /**
       *根据条件查询
       */
      loadData(data) {
        // console.log(data)
        this.loading = true;
        Promise.props({
          apps: getApps(),
          games: getGames(),
          appGames: getGamesConfig(data)
        }).then(result => {
          this.apps = result.apps;
          this.games = result.games;
          this.appGames = result.appGames;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      getAppProducts() {
        this.loading = true;
        // 获取商品配置
        getGamesConfig({
          ...this.searchForm
        }).then(result => {
          this.loading = false;
          this.appGames = result;
        }).catch(() => {
          this.loading = false;
        });
      },
      /**
       * 打开商品信息面板
       */
      showDialog(obj) {
        this.showEditorDialog = true;
        if (!obj) {
          this.title = '应用配置游戏';
          this.formData = defaultForm();
        } else {
          this.title = '修改应用游戏配置';
          this.formData = {
            ...obj
          };
        }

      },
      /**
       * 关闭面板
       */
      closeDialog() {
        this.clearForm();
        this.showEditorDialog = false;
      },
      clearForm() {
        this.$refs['formData'].resetFields();
      },

      handleBeforeCloseDialog(done) {
        this.clearForm();
        done();
      },

      /**
       * 提交前验证
       */
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.saveAppGames();
          } else {
            this.$message.error('提交失败');
            return false;
          }
        });
      },
      /**
       * 保存商品信息
       */
      saveAppGames() {
        const loading = this.$loading();
        if (this.formData.id) {
          updateGameConfig(this.formData).then(result => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            if (result) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.loadData();
            }
          }).catch(() => loading.close());
        } else {
          saveGameConfig(this.formData).then(() => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.loadData();
          }).catch(() => loading.close());
        }
      },
      /**
       * 删除
       */
      deleteAppGames(obj) {
        this.$confirm('确认删除该应用配置吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading();
          deleteGameConfig({id: obj.id, appIndex: obj.appIndex}).then(result => {
            loading.close();
            if (result > 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.loadData();
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleSizeChange(val) {
        this.loadData({
          page: this.appGames && this.appGames.currentPage,
          pageSize: val
        });
      },
      handleCurrentChange(val) {
        this.loadData({
          page: val
        });
      },
      _Find_,
      findAppName(index) {
        return this._Find_(this.apps, {appIndex: index}).appName
      },
      findGameName(key) {
        return this._Find_(this.games, {appKey: key}).name
      },
      statusChange(row) {
        let oldValue = null
        if (row.status === STATUS.DISABLE) {
          oldValue = STATUS.ENABLE
        } else {
          oldValue = STATUS.DISABLE
        }

        updateGamesStatus({id: row.id, status: row.status, appIndex: row.appIndex}).then(resutl => {
          if (!resutl) {
            this.$message.error('状态修改失败')
            row.status = oldValue
          } else {
            this.$message.success('状态修改成功')
          }
        }).catch(() => {
          this.$message.error('状态修改失败')
          row.status = oldValue
        })
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .update {
    margin-top: 10px;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }
    .img-box {
      width: 100px;
      height: 100px;
    }
    .number-input {
      width: 195px;
    }

    .form-item__full-width .el-select,
    .form-item__full-width .el-input-number {
      width: 100%;
    }

  }
</style>

<style>
  /*这里是elementUI组件自动生成的元素*/

  .el-upload-dragger {
    width: 100px;
    height: 100px;
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
</style>




// WEBPACK FOOTER //
// appGames.vue?0e1a403e